import { ReactNode } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { device } from "../theme/Breakpoints";
import { Color } from "../theme/Color";
import { FontSizes } from "../theme/FontSize";
import PageSection from "./PageSection";
import Spacer from "./Spacer";

interface Props {
  fullHeight?: boolean;
  background?: string;
  backgroundOverlayOpacity?: number;
  children: ReactNode;
  image: ReactNode;
}

const StyledHeroSection = styled(PageSection)<{ background: string }>`
  position: relative;
  background: ${({ background }) =>
    background ? `url(${background}) center center no-repeat` : Color.White};
  background-size: ${({ background }) => (background ? "cover" : "")};
`;

const StyledOverlay = styled.div<{ opacity: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, ${(props) => props.opacity});
  z-index: 1;
  pointer-events: none;
`;

export const HeroTitle = styled.h1`
  font-size: ${FontSizes[4]};
  font-weight: bold;
  text-transform: uppercase;
  line-height: 150%;
  margin-bottom: 2rem;
  text-align: left;

  @media ${device.mdAndWider} {
    font-size: ${FontSizes[6]};
  }
`;

export const HeroH2 = styled.h2`
  font-size: ${FontSizes[3]};
  font-weight: bold;
  line-height: 160%;
  text-align: left;
  margin-bottom: 2rem;
  text-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
`;

export const HeroH3 = styled.h3`
  font-size: ${FontSizes[1]};
  line-height: 160%;
  text-align: left;
  margin-bottom: 1.5rem;
  text-shadow: 1px 1px 7px rgba(0, 0, 0, 0.3);
`;

const HeroSection = ({
  fullHeight = false,
  background,
  backgroundOverlayOpacity = 0,
  children,
  image,
}: Props) => {
  return (
    <StyledHeroSection background={background} fullHeight={fullHeight}>
      <StyledOverlay opacity={backgroundOverlayOpacity}></StyledOverlay>
      <Row
        middle="xs"
        center="xs"
        style={{ zIndex: "2", position: "relative" }}
      >
        <Col xs={12} sm={8} lg={8}>
          <Spacer top={2} bottom={2}>
            {children}
          </Spacer>
        </Col>
        <Col xs={false} sm={4} lg={4}>
          <Row end="xs">
            <Spacer all={4}>{image}</Spacer>
          </Row>
        </Col>
      </Row>
    </StyledHeroSection>
  );
};

export default HeroSection;
